// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-input {
  font-size: 15px;
}

.textarea-small-margin .text-input-md {
  margin: 5px 8px;
}

.inupt-field {
  height: 100%;
}

.inupt-field .item-block {
  padding: 0;
}

.field-box {
  padding: 2px 0;
  background: #ffffff;
  height: 100%;
}

.field-box.item-md.item-block .item-inner {
  border: 0;
}

.field-title {
  color: #323b42;
  font-weight: 500;
  padding: 5px 3px;
  font-size: 13px;
}

ion-label.field-title {
  padding: 0 2px;
}

.field-text {
  border: 1px solid #eeeeee;
  border-radius: 5px;
  color: #323b42;
  font-weight: 500;
  padding: 0px;
  font-size: 13px;
  min-height: 26px;
  background: #ffffff;
}

.field-text input {
  border: 0;
  padding: 7px;
  width: 100%;
}

.field-text textarea {
  border: 0;
  padding: 7px;
  width: 100%;
}

.field-text .text-input-md {
  margin: 5px 8px;
}

.field-text.padding {
  padding: 5px;
}

.field-text .datetime-md {
  padding: 5px;
}

.field-text .custom-height textarea {
  height: -webkit-fill-available;
}

.field-text textarea {
  resize: none;
}

.field-text ion-datetime {
  padding: 3px;
  font-size: 16px;
}

.calendar-title {
  background: #2e3842;
  color: #fff;
  padding: 5px;
  font-size: 16px;
}

.margin-auto {
  margin: auto;
}`, "",{"version":3,"sources":["webpack://./src/framework/components/field/autofield/autofield.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAMA;EACE,YAAA;AAHF;;AASA;EACE,UAAA;AANF;;AASA;EACE,cAAA;EACA,mBAAA;EACA,YAAA;AANF;;AASA;EACE,SAAA;AANF;;AAaA;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAVF;;AAaA;EACE,cAAA;AAVF;;AAaA;EACE,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EAEA,gBAAA;EACA,mBAAA;AAXF;;AAcA;EAEE,SAAA;EACA,YAAA;EACA,WAAA;AAZF;;AAcA;EAEE,SAAA;EACA,YAAA;EACA,WAAA;AAZF;;AAeA;EACE,eAAA;AAZF;;AAeA;EAEE,YAAA;AAbF;;AAgBA;EACE,YAAA;AAbF;;AAgBA;EAEE,8BAAA;AAdF;;AAiBA;EAEE,YAAA;AAfF;;AAkBA;EAEE,YAAA;EACA,eAAA;AAhBF;;AAmBA;EAEE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAjBF;;AAoBA;EAEE,YAAA;AAlBF","sourcesContent":[".text-input {\n  font-size: 15px;\n}\n\n.textarea-small-margin .text-input-md {\n  margin: 5px 8px;\n}\n\n// .inupt-field>div>ion-row {\n//   height: 14px;\n// }\n\n.inupt-field {\n  height: 100%;\n}\n.inupt-field ion-label {\n  //padding: 0 20px;\n}\n\n.inupt-field .item-block {\n  padding: 0;\n}\n\n.field-box {\n  padding: 2px 0;\n  background: #ffffff;\n  height: 100%;\n}\n\n.field-box.item-md.item-block .item-inner {\n  border: 0;\n}\n\n.field-box.item-md.item-block .item-inner .input-wrapper {\n  //max-width: 25%;\n}\n\n.field-title {\n  color: #323b42;\n  font-weight: 500;\n  padding: 5px 3px;\n  font-size: 13px;\n}\n\nion-label.field-title {\n  padding: 0 2px\n}\n\n.field-text {\n  border: 1px solid #eeeeee;\n  border-radius: 5px;\n  color: #323b42;\n  font-weight: 500;\n  padding: 0px;\n  font-size: 13px;\n  // max-width: 170px;\n  min-height: 26px;\n  background: #ffffff;\n}\n\n.field-text input\n{\n  border: 0;\n  padding: 7px;\n  width:100%;\n}\n.field-text textarea\n{\n  border: 0;\n  padding: 7px;\n  width:100%;\n}\n\n.field-text .text-input-md {\n  margin: 5px 8px;\n}\n\n.field-text.padding\n{\n  padding: 5px;\n}\n\n.field-text .datetime-md {\n  padding: 5px;\n}\n\n.field-text .custom-height textarea\n{\n  height: -webkit-fill-available;\n}\n\n.field-text textarea\n{\n  resize: none;\n}\n\n.field-text ion-datetime\n{\n  padding: 3px;\n  font-size: 16px;\n}\n\n.calendar-title\n{\n  background: #2e3842;\n  color: #fff;\n  padding: 5px;\n  font-size: 16px;\n}\n\n.margin-auto\n{\n  margin: auto;\n}\n\n//.rtl{\n//::ng-deep{\n//.field-text\n//{\n//  ion-datetime.datetime-box\n//  {\n//    :host ::ng-deep .datetime-text {\n//      background: #0ec254;\n//      direction: rtl\n//    }\n//      //direction: rtl;\n//  }\n//}\n //\n//}\n//}\n//\n//.ltr{\n//\n//  ion-datetime .datetime-text\n//  {\n//    direction: ltr;\n//  }\n//}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
